var lx = lx || {};
lx.map = {
    type: 'T',
    map: {}, 
    geocoder: null,
    infoWindow: {},
    markers: [],
    bounds: {},
    boundsDir: {},
    emps: [], 
    events: [],
    assets: [],
    refreshInterval: {},
    timerInterval: {},
    gmapStyles: [
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [
                  { visibility: "off" }
            ]
        }
    ],
    getMapStyles: () => {
        const colors = getComputedStyle(document.documentElement);
        const dark = document.documentElement.dataset.lpTheme == 'dark';
        let styles = dark ? [
            {elementType: 'geometry', stylers: [{color: colors.getPropertyValue('--lp-raised').trim() || '#292929'}]},
            {elementType: 'labels.text.fill', stylers: [{color: colors.getPropertyValue('--lp-muted').trim() || '#b0b0b0'}]},
            {elementType: 'labels.text.stroke', stylers: [{color: colors.getPropertyValue('--lp-bg').trim() || '#191919'}]},
            {featureType: 'road', elementType: 'geometry', stylers: [{color: colors.getPropertyValue('--lp-border').trim() || '#383838'}]},
            {featureType: 'water', elementType: 'geometry', stylers: [{color: colors.getPropertyValue('--lp-bg').trim() || '#191919'}]},
            {featureType: 'poi.park', elementType: 'geometry', stylers: [{color: colors.getPropertyValue('--lp-surface').trim() || '#222222'}]}
        ] : [];
        const poi = document.querySelector('#lxMapFilter input[value="I"]');
        if (!poi || !poi.checked) styles = styles.concat(lx.map.gmapStyles);
        return styles;
    },
    applyTheme: () => {
        if (typeof lx.map.map.setOptions === 'function') lx.map.map.setOptions({styles: lx.map.getMapStyles()});
    },
    filterVal: [],
    fitBounds: () => {
        if (!lx.map.bounds || typeof lx.map.bounds.isEmpty !== 'function' || lx.map.bounds.isEmpty()) return;
        // maximum zoom when using bounds zooming (so if there is only one pin it does not zoom too much)
        let maxZoom = 14;
        google.maps.event.addListenerOnce(lx.map.map, 'bounds_changed', function(event) { if (this.getZoom() > maxZoom)  this.setZoom(maxZoom); });
        if ( !$("#SR_map_tab").hasClass("a-Tabs-selected")) $("#SR_map_tab").trigger("click");
        lx.map.map.fitBounds(lx.map.bounds);
    },
    reBoundPending: false,
    reBound: () => {
        if ( !$("#SR_map_tab").hasClass("a-Tabs-selected") ) {
            lx.map.reBoundPending = true;
        } else {
            lx.map.reBoundPending = false;
            lx.map.bounds = new google.maps.LatLngBounds();
            for (let i = 0; i < lx.map.emps.length; i++) {
                const b = lx.map.emps[i];
                if (b.pin) lx.map.bounds.extend(b.latlng);
            }
            for (let i = 0; i < lx.map.events.length; i++) {
                const b = lx.map.events[i];
                if (b.pin) lx.map.bounds.extend(b.latlng);
            }
            for (let i = 0; i < lx.map.assets.length; i++) {
                const b = lx.map.assets[i];
                if (b.pin) lx.map.bounds.extend(b.latlng);
            }
            lx.map.fitBounds(lx.map.bounds);
        }
    },
    MarkerPerson: function (id, latlng, label, img) { 
        this.mType = 'P';
        this.id = id;
        this.latlng_ = latlng;
        this.img = img;
        this.label = label;
        this.setMap(lx.map.map);
    },
    MarkerEvent: function (id, latlng, label) {
        this.mType = 'E';
        this.id = id;
        this.latlng_ = latlng;
        this.label = label;
        this.setMap(lx.map.map);
    },
    MarkerAsset: function (id, latlng, label, type, icon) {
        this.mType = 'A';
        this.id = id;
        this.latlng_ = latlng;
        this.label = label;
        this.type = type;
        this.icon = icon;
        this.setMap(lx.map.map);
    },
    addressFormGetGeodata: (req) => {
        /* Used on pages 32 and 413 so geolocation is immediatly populated
        */
        let pageId = $v("pFlowStepId");
        if (pageId == 413 && ( $v("P"+pageId+"_VALID_GEOCODE") == 'I' || $v("P413_ADDRESS_TYPE_BILLING") != 'M') ){
            if (req) apex.page.submit(req);
            return;
        }
        let missingMandatoryField = false;
        let address = "";
        addAddressElement('P'+pageId+'_ADDRESS', true);
        addAddressElement('P'+pageId+'_ADDRESS2');
        addAddressElement('P'+pageId+'_CITY', true);
        addAddressElement('P'+pageId+'_POSTAL_CODE');
        addAddressElement('P'+pageId+'_STATE_ID');
        addAddressElement('P'+pageId+'_COUNTRY_ID', true, true);
        $s('P'+pageId+'_LAT', "");
        $s('P'+pageId+'_LNG', "");
        $s('P'+pageId+'_VALID_GEOCODE', "N");
        if (!missingMandatoryField) {
            if (!lx.map.geocoder) {
                lx.map.geocoder = new google.maps.Geocoder();
            }
            lx.map.geocoder.geocode({'address': address}, function(results, status) {
                lx.map.geocodeRequestCnt--;
                if (status === 'OK') {
                    $s('P'+pageId+'_LAT', results[0].geometry.location.lat());
                    $s('P'+pageId+'_LNG', results[0].geometry.location.lng());
                    $s('P'+pageId+'_VALID_GEOCODE', "Y");
                    console.log("Geocode sucessfull");
                } else if (status === 'OVER_QUERY_LIMIT') {
                    //lx.info.err("Try again!");
                    console.log("Over query Limit");
                } else if (status === 'UNKNOWN_ERROR') {
                    //lx.info.err("Try again!");
                    console.log("Unknown error, try again!");
                } else if (status === 'ZERO_RESULTS') {
                    $s('P'+pageId+'_VALID_GEOCODE', "I");
                    //lx.info.error("Address '"+  address +"' is not possible to geocode, please review it!");
                    console.log("Address '"+  address +"' is not possible to geocode, please review it!");
                    // TODO flag db record
                } else {
                    $s('P'+pageId+'_VALID_GEOCODE', "I");
                    //lx.info.error("Something went wrong with processing of address: "+ d.address );
                    console.log('Geocode was not successful for the following reason: ' + status +' > "'+ d.address +'"');
                }
                if (req) apex.page.submit(req);
            });
        } else if (req) apex.page.submit(req);

        function addAddressElement(pItem, pMandatory, pLast){
            let val;
            let item = $("#"+pItem);
            if (item.hasClass("popup_lov")) val = item.val();
            else if (item.hasClass("selectlist")) val = $f_SelectedOptions(pItem).text;
            else val = $v(pItem);

            if (val) address += val + (!pLast ? ', ' : '');
            else if (pMandatory) missingMandatoryField = true;
        }
    },
    geocodeRequestCnt: 0,
    geocodeRequestLimit: 25,
    addPerson: (d, pan, pToggle) => {
        let pin = d;
        if (!pToggle) {
            lx.map.emps.push(d);
            pin = lx.map.emps[lx.map.emps.length-1];
        }
        if (d.pos && (lx.map.type == "T" || pToggle) ){
            pin.latlng = new google.maps.LatLng(pin.pos.lat, pin.pos.lng);
            pin.pin = new lx.map.MarkerPerson(pin.pid, pin.latlng, pin.label, pin.img);
            lx.map.markerCluster.addMarker(pin.pin);
            if (pan) lx.map.bounds.extend(pin.latlng);
        } else if (d.address && d.validGeocode == 'N' && pToggle) {
            
            if (lx.map.geocodeRequestCnt >= lx.map.geocodeRequestLimit ) setTimeout( () => { lx.map.addPerson(d, pan, pToggle); }, 1000);
            else {
                lx.map.geocodeRequestCnt++;
                lx.map.geocoder.geocode({'address': d.address}, function(results, status) {
                    lx.map.geocodeRequestCnt--;
                    if (status === 'OK') {
                        pin.latlng = results[0].geometry.location;
                        pin.pos = {lat: pin.latlng.lat(), lng: pin.latlng.lng() };
                        lx.map.addPerson(pin, pan, pToggle);
                        lx.map.setAddressLatLng(d.addrId, pin.pos.lat, pin.pos.lng, 'Y');
                    } else if (status === 'OVER_QUERY_LIMIT') {
                        setTimeout( () => { lx.map.addPerson(d, pan, pToggle); }, 2000);
                    } else if (status === 'UNKNOWN_ERROR') {
                        lx.map.setAddressLatLng(d.addrId, 0, 0, 'N');
                    } else if (status === 'ZERO_RESULTS') {
                        lx.map.setAddressLatLng(d.addrId, 0, 0, 'I');
                        lx.info.error("Address '"+  d.address +"' for '"+ d.label +"' is not possible to geocode, please review it!");
                    } else {
                        lx.map.setAddressLatLng(d.addrId, 0, 0, 'N');
                        lx.info.error("Something went wrong with processing of address: "+ d.address );
                        console.log('Geocode was not successful for the following reason: ' + status +' > "'+ d.address +'"');
                    }
                });
            }
        }
    },
    addEvent: (d, pan) => {
        lx.map.events.push({id: d.id, label: d.label, typeCode: d.typeCode, time: d.time, rsvp: d.rsvp});
        if (d.location){
            let pin = lx.map.events[lx.map.events.length-1];
            
            if (lx.map.geocodeRequestCnt >= lx.map.geocodeRequestLimit ) setTimeout( () => { lx.map.addEvent(d, pan); }, 1000);
            else {
                lx.map.geocodeRequestCnt++;
                lx.map.geocoder.geocode({'address': d.location}, function(results, status) {
                    lx.map.geocodeRequestCnt--;
                    if (status === 'OK') {
                        pin.latlng = results[0].geometry.location;
                        /*lx.map.markers.push( new lx.map.MarkerEvent(d.id, pin.latlng, d.label) );
                        pin.pin = lx.map.markers[lx.map.markers.length-1];*/
                        pin.pin = new lx.map.MarkerEvent(d.id, pin.latlng, d.label);
                        lx.map.markerCluster.addMarker(pin.pin);
                        if (pan) lx.map.bounds.extend(pin.latlng);
                    } else if (status === 'OVER_QUERY_LIMIT') {
                        setTimeout( () => { lx.map.addEvent(d, pan); }, 2000);
                    } else if (status === 'ZERO_RESULTS') {
                        lx.info.error("Address '"+  d.location +"' for '"+ d.label +"' is not possible to geocode, please review it!");
                    } else {
                        lx.info.error("Something went wrong with processing of address: "+ d.address );
                    console.log('Geocode was not successful for the following reason: ' + status +' > "'+ d.location +'"');
                    }
                });
            }
        }
    },
    addAsset: (d, pan, pToggle, fitBounds) => {
        let pin = d;
        if (!pToggle) {
            lx.map.assets.push(d);
            pin = lx.map.assets[lx.map.assets.length-1];
        }
        if (pin.pos && (lx.map.type == "T" || pToggle) ){
            pin.latlng = new google.maps.LatLng(pin.pos.lat, pin.pos.lng);
            pin.pin = new lx.map.MarkerAsset(pin.id, pin.latlng, pin.label, pin.typeCode, pin.icon);
            lx.map.markerCluster.addMarker(pin.pin);
            if (pin.asig.length == 0 || pin.typeCode.startsWith('BLD')) {
                if (pan) {
                    lx.map.bounds.extend(pin.latlng);
                    //if (fitBounds && lx.map.type != "T") lx.map.fitBounds(lx.map.bounds);
                }
            } else {
                lx.map.markerCluster.removeMarker(pin.pin);
            }
        } else if (d.location && pToggle){
            
            if (lx.map.geocodeRequestCnt >= lx.map.geocodeRequestLimit ) setTimeout( () => { lx.map.addAsset(d, pan, pToggle, fitBounds); }, 1000);
            else {
                lx.map.geocodeRequestCnt++;
                lx.map.geocoder.geocode({'address': pin.location}, function(results, status) {
                    lx.map.geocodeRequestCnt--;
                    if (status === 'OK') {
                        pin.latlng = results[0].geometry.location;
                        pin.pos = {lat: pin.latlng.lat(), lng: pin.latlng.lng() };
                        lx.map.addAsset(pin, pan, pToggle, fitBounds);
                        //lx.map.setAssetLatLng(d.id, pin.pos.lat, pin.pos.lng);
                    } else if (status === 'OVER_QUERY_LIMIT') {
                        setTimeout( () => { lx.map.addAsset(d, pan, pToggle, fitBounds); }, 2000);
                    } else if (status === 'ZERO_RESULTS') {
                        lx.info.error("Address '"+  d.location +"' for '"+ d.label +"' is not possible to geocode, please review it!");
                    } else {
                        lx.info.error("Something went wrong with processing of address: "+ d.address );
                        console.log('Geocode was not successful for the following reason: ' + status +' > "'+ pin.location +'"');
                    }
                });
            }
        }
    },
    timerDisp: (i) => {
		if (i.t == 'NONE')  {return "00:00"}
		else {
        return (i.d > 0 ? i.d + "d " : "")+
             String(i.h).padStart(2,'0')+":"+
             String(i.m).padStart(2,'0')+":"+
             String(i.s).padStart(2,'0')
		}
		
    },
    timerBump: () => {
        for (let j = 0; j < lx.map.events.length; j++){
            let addM,addH,addD;
            //if (lx.map.events[j].typeCode.startsWith("I_")) {
                let i = lx.map.events[j].time;
                //seconds
                if (i.s == 59) {
                    addM = true;
                    i.s = 0;
                } else i.s++;
                // minutes
                if (addM){
                    if (i.m == 59){
                        addH = true;
                        i.m = 0;
                    } else i.m++;
                }
                // hours
                if (addH) {
                    if (i.h == 23){
                        addD = true;
                        i.h = 0;
                    } else i.h++;
                }
                // days
                if (addD) {
                    i.d++;
                }
                $("#E"+ lx.map.events[j].id +" .timer").text(lx.map.timerDisp(i));
            //}
        }
    },
    initMarkers: () => {
        // Person
        lx.map.MarkerPerson.prototype = new google.maps.OverlayView();
        lx.map.MarkerPerson.prototype.draw = function () {
            // Check if the div has been created.
            let div = this.div_;
            let self = this;
            if (!div) {
                // Create a overlay text DIV
                div = this.div_ = document.createElement('div');
                // Create the DIV representing our CustomMarker
                div.className = "customMarker"; //replaced styles with className

                $(div).append( '<i class="fas fawe-map-marker-alt pin"></i>'+ lx.profile.genPic(this.img) + '<div class="label">'+ this.label +'</div>' );
                google.maps.event.addDomListener(div, "click", function (event) {
                    lx.map.selectAsset(self.id, 'P');
                    google.maps.event.trigger(self, "click");
                });

                // Then add the overlay to the DOM
                let panes = this.getPanes();
                panes.overlayImage.appendChild(div);
            }

            // Position the overlay 
            let point = this.getProjection().fromLatLngToDivPixel(this.latlng_);
            if (point) {
                div.style.left = point.x + 'px';
                div.style.top = point.y + 'px';
            }
        };
        lx.map.MarkerPerson.prototype.remove = function () {
            // Check if the overlay was on the map and needs to be removed.
            if (this.div_) {
                this.div_.parentNode.removeChild(this.div_);
                this.div_ = null;
            }
        };
        lx.map.MarkerPerson.prototype.getPosition = function () {
            return this.latlng_;
        };
        lx.map.MarkerPerson.prototype.setPosition = function (latlng) {
            this.latlng_ = latlng;
            // Position the overlay 
            let point = this.getProjection().fromLatLngToDivPixel(this.latlng_);
            if (point) {
                this.div_.style.left = point.x + 'px';
                this.div_.style.top = point.y + 'px';
            }
        };

        // Event
        lx.map.MarkerEvent.prototype = new google.maps.OverlayView();
        lx.map.MarkerEvent.prototype.draw = function () {
            // Check if the div has been created.
            let div = this.div_;
            let self = this;
            if (!div && this.latlng_) {
                // Create a overlay text DIV
                div = this.div_ = document.createElement('div');
                // Create the DIV representing our CustomMarker
                div.className = "customMarker eventMarker"; //replaced styles with className

                $(div).append( '<i class="fas fawe-map-marker-alt pin"></i>' + '<div class="label">'+ this.label +'</div>' );
                google.maps.event.addDomListener(div, "click", function (event) {
                    lx.map.selectAsset(self.id, 'E');
                    google.maps.event.trigger(self, "click");
                });

                // Then add the overlay to the DOM
                let panes = this.getPanes();
                panes.overlayImage.appendChild(div);
            }

            // Position the overlay 
            let point = this.getProjection().fromLatLngToDivPixel(this.latlng_);
            if (point) {
                div.style.left = point.x + 'px';
                div.style.top = point.y + 'px';
            }
        };
        lx.map.MarkerEvent.prototype.remove = function () {
            // Check if the overlay was on the map and needs to be removed.
            if (this.div_) {
                this.div_.parentNode.removeChild(this.div_);
                this.div_ = null;
            }
        };
        lx.map.MarkerEvent.prototype.getPosition = function () {
            return this.latlng_;
        };
        lx.map.MarkerEvent.prototype.setPosition = function (latlng) {
            this.latlng_ = latlng;
            this.draw();
        };

        // Asset
        lx.map.MarkerAsset.prototype = new google.maps.OverlayView();
        lx.map.MarkerAsset.prototype.draw = function () {
            // Check if the div has been created.
            let div = this.div_;
            let self = this;
            if (!div && this.latlng_) {
                // Create a overlay text DIV
                div = this.div_ = document.createElement('div');
                // Create the DIV representing our CustomMarker
                div.className = "customMarker assetMarker " + this.type; //replaced styles with className

                $(div).append( '<i class="fas fawe-map-marker-alt pin"></i>'+ '<i class="'+ this.icon +' aIcon"></i>' + '<div class="label">'+ this.label +'</div>' );
                google.maps.event.addDomListener(div, "click", function (event) {
                    lx.map.selectAsset(self.id, 'A');
                    google.maps.event.trigger(self, "click");
                });

                // Then add the overlay to the DOM
                let panes = this.getPanes();
                panes.overlayImage.appendChild(div);
            }

            // Position the overlay 
            let point = this.getProjection().fromLatLngToDivPixel(this.latlng_);
            if (point) {
                div.style.left = point.x + 'px';
                div.style.top = point.y + 'px';
            }
        };
        lx.map.MarkerAsset.prototype.remove = function () {
            // Check if the overlay was on the map and needs to be removed.
            if (this.div_) {
                this.div_.parentNode.removeChild(this.div_);
                this.div_ = null;
            }
        };
        lx.map.MarkerAsset.prototype.getPosition = function () {
            return this.latlng_;
        };
        lx.map.MarkerAsset.prototype.setPosition = function (latlng) {
            this.latlng_ = latlng;
            this.draw();
        };
    },
    initMap: (pType) => {
        if (pType) lx.map.type = pType;

        $("#btnCreateAsset").hide();
        lx.map.map = new google.maps.Map(document.getElementById("map"), {
          center: { lat: 0, lng: 0 },
          zoom: 2,
          controlSize: 44,
          styles: lx.map.getMapStyles()
        });
        lx.map.bounds = new google.maps.LatLngBounds();
        lx.map.geocoder = new google.maps.Geocoder();
        lx.map.markerCluster = new MarkerClusterer(lx.map.map, lx.map.markers, {imagePath:'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
        lx.map.infoWindow = new google.maps.InfoWindow();
        // add map special behaviour
        google.maps.event.addListener(lx.map.markerCluster, 'clusterclick', (cluster, event) => {
            if (cluster.getMarkers().length > 1) {
              const markers = cluster.getMarkers();
              let isOverlappedCluster = true;
        
              markers.slice(1).reduce((prevMarker, marker) => {
                if (marker.getPosition().equals(prevMarker.getPosition()) === false) {
                  isOverlappedCluster = false;
                }
        
                return marker;
              }, markers[0]);
        
              if (isOverlappedCluster) {
                let html = "";
                for (let i = 0; i < markers.length; i++) {
                    const m = markers[i];
                    html += '<p>'+'<i class="'+ (m.mType == 'A' ? m.icon :(m.mType == 'P' ? 'fas fawe-user' : 'fas fawe-map-marker-alt') ) +'"></i> '+ m.label +'</p>';
                }
                lx.map.infoWindow.setContent( html );
                lx.map.infoWindow.setPosition(cluster.getCenter());
                lx.map.infoWindow.open(lx.map.map);
                // possibility of moving markers a tiny bit
                //markers[0].setPosition(new google.maps.LatLng(markers[0].getPosition().lat() + 0.0005, markers[0].getPosition().lng() + 0.0005))
              }
            }
        });
        lx.map.initMarkers();
        lx.map.getPins(true);
        // map filters
        $("#SR_map .apex-item-option input").on('click', (e)=> { lx.map.filterMap(e); } );
        // populate so we have old value to compare
        lx.map.filterVal = $v('lxMapFilter').split(":");
        // set refresh intervals
        if (lx.map.type == 'T') {
            lx.map.refreshInterval = setInterval(lx.map.getPins, 30000);
            lx.map.timerInterval = setInterval(() => {lx.map.timerBump();lx.map.getPinsOnly();}, 1000);
        } else {
            lx.map.directionsService = new google.maps.DirectionsService();
            lx.map.directionsRenderer = new google.maps.DirectionsRenderer();
            lx.map.distanceMatrix = new google.maps.DistanceMatrixService();
            lx.map.directionsRenderer.setMap(lx.map.map);
            $("#details .travelMode > i").on('click', (e)=> { lx.map.setTravelMode(e); } );
            $('#printRoutes').hide();
        }
    },
    dragStart: function (e) {
        e.dataTransfer.setData('text/plain', e.target.getAttribute('data-cid') );
        //e.target.classList.add('hide');
    },
    dragEvent: {
        drop: function (e) {
            let eventId = e.target.getAttribute('data-id');
            if (eventId == null) eventId = $(e.target).closest(".event").attr('data-id');
            let personId = $('.person[data-cid='+ e.dataTransfer.getData('text/plain') +']').data('id');
            lx.map.handleEventPerson(eventId, personId, 'A');
            this.classList.remove('over');
            e.stopPropagation();
            e.preventDefault();
            return false;
        },
        over: function (e) {
            e.preventDefault();
            this.classList.add('over');
        },
        enter: function (e) {
            e.preventDefault();
            this.classList.add('over');
        },
        leave: function (e) {
            e.preventDefault();
            this.classList.remove('over');
        },
    },
    dragAsset: {
        drop: function (e) {
            let assetId = e.target.getAttribute('data-id');
            if (assetId == null) assetId = $(e.target).closest(".asset").attr('data-id');
            lx.map.handleAssetPerson(assetId,  e.dataTransfer.getData('text/plain'), 'A');
            this.classList.remove('over');
            e.stopPropagation();
            e.preventDefault();
            return false;
        },
        over: function (e) {
            e.preventDefault();
            this.classList.add('over');
        },
        enter: function (e) {
            e.preventDefault();
            this.classList.add('over');
        },
        leave: function (e) {
            e.preventDefault();
            this.classList.remove('over');
        },
    },
    selectAsset: (id, pType, pThis) => {
        let zoomLevel = lx.map.map.getZoom();
        let zoomDefault = 14;
        if (pType == 'E'){
            for (let j = 0; j < lx.map.events.length; j++){
                if (lx.map.events[j].id == id) {
                    let pin = lx.map.events[j].pin;
                    if (pin) {
                        if (!$("#SR_map_tab").hasClass("a-Tabs-selected")) $("#SR_map_tab").trigger("click");
                        lx.map.map.panTo(pin.latlng_);
                        if (zoomLevel < zoomDefault) lx.map.map.setZoom(zoomDefault);
                        else lx.map.map.setZoom(zoomLevel+1);
                    }
                    break;
                }
            }
        } else if (pType == 'A'){
            for (let j = 0; j < lx.map.assets.length; j++){
                if (lx.map.assets[j].id == id) {
                    let pin = lx.map.assets[j].pin;
                    if (pin) {
                        if (!$("#SR_map_tab").hasClass("a-Tabs-selected")) $("#SR_map_tab").trigger("click");
                        lx.map.map.panTo(pin.latlng_);
                        if (zoomLevel < zoomDefault) lx.map.map.setZoom(zoomDefault);
                        else lx.map.map.setZoom(zoomLevel+1);
                    }
                    break;
                }
            }
        } else {
            for (let j = 0; j < lx.map.emps.length; j++){
                if (lx.map.emps[j].pid == id) {
                    let pin = lx.map.emps[j].pin;
                    if (pin) {
                        if (!$("#SR_map_tab").hasClass("a-Tabs-selected")) $("#SR_map_tab").trigger("click");
                        lx.map.map.panTo(pin.latlng_);
                        if (zoomLevel < zoomDefault) lx.map.map.setZoom(zoomDefault);
                        else lx.map.map.setZoom(zoomLevel+1);
                    }
                    //lx.map.hideDetails('S');
                    break;
                }
            }
        }
        if (lx.map.type == 'T') lx.map.hideDetails(pType, id);
    },
    overview: () => {
        let bounds = new google.maps.LatLngBounds();
        let filter = $v('lxMapFilter').split(":");
        // Employees
        if ( filter.includes("P") )
            for (let i = 0; i < lx.map.emps.length; i++) {
                const item = lx.map.emps[i];
                if (item.latlng) bounds.extend(item.latlng);
            }
        if ( filter.includes("E") )
            for (let i = 0; i < lx.map.events.length; i++) {
                const item = lx.map.events[i];
                if (item.latlng) bounds.extend(item.latlng);
            }
        if ( filter.includes("A") )
            for (let i = 0; i < lx.map.assets.length; i++) {
                const item = lx.map.assets[i];
                if (item.latlng) bounds.extend(item.latlng);
            }
        lx.map.fitBounds(bounds);
        $("#SR_map_tab").trigger("click");
    },
    eventPerson: (eventId, rec) => {
        return '<div class="rec" data-pid="'+ rec.pid +'">'+
                                '<div class="img">'+ lx.profile.genPic(rec.img) +'</div>'+
                                '<div class="recName">'+ rec.name +' | <span class="started"><i class="fas fawe-sign-in"></i> '+ rec.start +'</span>'+'</div>'+
                                '<i class="fas fawe-sign-out"  onclick="lx.map.handleEventPerson('+ eventId +','+ rec.pid +',\'L\')" title="Leave"></i>'+
                                '<i class="fas fawe-trash-alt" onclick="lx.map.handleEventPerson('+ eventId +','+ rec.pid +',\'D\')" title="Delete"></i>'+
                            '</div>';
    },
    assetPerson: (assetId, rec) => {
        return '<div class="rec" data-pid="'+ rec.pid +'" data-cid="'+ rec.cid +'">'+
                                '<div class="img">'+ (rec.img ? lx.profile.genPic(rec.img) : '') +'</div>'+
                                '<div class="recName">'+ rec.name +'</div>'+
                                '<i class="fas fawe-trash-alt" onclick="lx.map.handleAssetPerson('+ assetId +','+ rec.cid +',\'D\')"></i>'+
                            '</div>';
    },
    personAsset: (pContactId, asset) => {
        console.log(pContactId);
        $(".person[data-cid="+pContactId+'] .assetAssigned').append('<div class="pAsset '+ asset.typeCode +'" id="PA'+pContactId+'_'+ asset.id +'"><i class="'+ asset.icon +'"></i> '+ 
                                                    (asset.typeCode == 'EQP' || asset.typeCode == 'VHC' ? asset.sType : asset.label) +'</div>');
    },
    personEvent: (pPersonId, event) => {
        $("#P"+pPersonId+' .assetAssigned').prepend('<div class="pAsset pEvent" id="PE'+pPersonId+'_'+ event.id +'" onclick="lx.map.selectAsset('+ event.id +', \'E\')">'+
                                                    '<i class="fas fawe-map-marker-alt red"></i> '+
                                                    event.label +'</div>');
    },
    updatePin: (point, data) => {
        if (!point) return;
        if (data.gid) {
            const $time = $(".person[data-id="+ data.pid +"] .time");
            if (data.time && !point.gid) $time.attr('onclick', 'lx.map.selectAsset('+ data.pid +')').addClass("tracked");
            point.time = data.time;
            $time.html( '<i class="far fawe-clock" ></i> '+ (data.time ? data.time : 'Not tracked') );
            if (!point.gid || point.gid != data.gid){
                point.gid = data.gid;
                if (point.pin) lx.map.markerCluster.removeMarker(point.pin);
                point.latlng = new google.maps.LatLng( (data.pos ? data.pos.lat : data.lat), (data.pos ? data.pos.lng : data.lng) );
                point.pin = new lx.map.MarkerPerson(point.pid, point.latlng, point.label, point.img);
                lx.map.markerCluster.addMarker(point.pin);
            }
        }
    },
    togglePin: (pid, pThis) => {
        for (let j = 0; j < lx.map.emps.length; j++){
            let d = lx.map.emps[j];
            let $person = $(pThis).closest(".person");
            if (d.pid == pid) {
                if (d.pin) {
                    lx.map.markerCluster.removeMarker(d.pin);
                    d.pin = null;
                    $person.removeClass("pinned");//.find('.cbx').removeClass('fawe-check-square').addClass('fawe-square');
                    $("#R"+pid).remove();
                    if (lx.map.routes){
                        let index;
                        for (let i = 0; i < lx.map.routes.length; i++) {
                            const r = lx.map.routes[i];
                            if (d.addrId == r.addrId){
                                if (r.directionLine && r.directionLine.map) {
                                    r.directionLine.setMap(null);
                                }
                                index = i;
                                break
                            }
                        }
                        if (index) lx.map.routes.splice(index, 1);
                    }
                    lx.map.reBound();
                } else if (!d.hasAddress) {
                    lx.info.error("No address specified!");
                } else if (d.validGeocode == 'I'){
                    lx.info.error("Invalid address!");
                } else {
                    lx.map.addPerson (d, true, true);
                    setTimeout(()=>{
                        lx.map.fitBounds(lx.map.bounds);
                    }, 1000);
                    $person.addClass("pinned");//.find('.cbx').removeClass('fawe-square').addClass('fawe-check-square');
                    if (lx.map.type != 'T') {
                        $("#details").removeClass("hideDetails");  
                        $("#mapPanel").removeClass("col-10").addClass("col-8");
                        let $clone = $person.clone();
                        $clone.removeClass("pinned").addClass("route").attr("id", 'R'+$person.attr("id").substr(1) ).find(".cbx").remove();
                        $("#routeList").append( $clone );
                        lx.map.clearDirections();
                    }
                }
                break;
            }
        }
    },
    toggleAsset: (id, pThis) => {
        let currentAsset = Number($('.asset.pinned').attr("data-id"));
        
        for (let j = 0; j < lx.map.assets.length; j++){
            let d = lx.map.assets[j];
            if (d.id == id) {
                if (d.pin) {
                    lx.map.markerCluster.removeMarker(d.pin);
                    d.pin = null;
                    $(pThis).closest(".asset").removeClass("pinned").find('.cbx').removeClass('fawe-check-square').addClass('fawe-square');
                    lx.map.sortRouteSet(id, true);
                } else {
                    lx.map.addAsset (d, true, true, true);
                    /* setTimeout(()=>{
                        lx.map.fitBounds(lx.map.bounds);
                    }, 1000); */
                    $(pThis).closest(".asset").addClass("pinned").find('.cbx').removeClass('fawe-square').addClass('fawe-check-square');
                    //$("#SR_map_tab").trigger("click");
                    lx.map.sortRouteSet(id);
                }
            } else if (lx.map.type == 'C' && d.id == currentAsset){
                lx.map.markerCluster.removeMarker(d.pin);
                d.pin = null;
                $(".asset.pinned[data-id="+ d.id +"]").removeClass("pinned").find('.cbx').removeClass('fawe-check-square').addClass('fawe-square');
                lx.map.sortRouteSet(id, true);
            }
        }
        lx.map.reBound();
    },
    setPins: (d, pan) => {
        for (let i = 0; i < d.length; i++){
            let exists = false;
            for (let j = 0; j < lx.map.emps.length; j++){
                if (lx.map.emps[j].pid == d[i].pid) {
                    lx.map.updatePin(lx.map.emps[j], d[i]);
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                lx.map.addPerson (d[i], pan);
                let img = $.extend(true, {}, d[i].img);
                img.size = 'M';
                $("#people .content").append('<div id="P'+ d[i].pid +'" class="person contact'+ (d[i].gid ? ' pinned' : '') +'" draggable="true" data-id="'+ d[i].pid +'"'+
                                                ' data-cid="'+ d[i].cid +'"'+
                                                (lx.map.type == 'T' ? ' onclick="lx.map.hideDetails(\'P\','+ d[i].pid +')"' : '')+
                                                ( d[i].addrId ? ' data-addr="'+ d[i].addrId +'"' : '')+
                                                '>'+
                                    '<div class="cbx" onclick="lx.map.togglePin('+ d[i].pid +',this)"></div>'+
                                    '<div class="img">'+ lx.profile.genPic(img) +'</div>'+
                                    '<div class="txt">'+
                                            (d[i].tags ? '<div class="tags">'+ d[i].tags.map(v => '<span>'+v.name+'</span>').join(' ') +'</div>' : '')+
                                             '<div class="name">'+ d[i].label +'</div>'+
                                             (d[i].wp ? '<div class="wp">'+ d[i].wp +'</div>' : '')+
                                             (d[i].dep ? '<div class="wp dep">'+ d[i].dep +'</div>' : '')+
                                             (lx.map.type == 'T' ? '<div class="time'+ (d[i].time ? ' tracked" onclick="lx.map.selectAsset('+ d[i].pid +')' : '') +'">'+
                                                                  '<i class="far fawe-clock" ></i> '+ (d[i].time ? d[i].time : 'Not tracked') +'</div>'
                                                                : '') +
                                             (d[i].address ? '<div class="address"><i class="fas fawe-map-marker-alt" ></i> '+ d[i].address +'</div>' : '')+
                                    '</div>'+
                                    '<div class="assetAssigned"></div>'+
                                    '</div>');
                const item = document.getElementById("P"+ d[i].pid );
                item.addEventListener('dragstart', lx.map.dragStart );
            }
        }
        
    },
    setEvents: (d, pan) => {
        if (!d) return;
        for (let i = 0; i < d.length; i++){
            let exists = false;
            for (let j = 0; j < lx.map.events.length; j++){
                if (lx.map.events[j].id == d[i].id) {
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                lx.map.addEvent (d[i], pan);
                // rsvp records
                let rsvp = "";
                for(let k = 0; k < d[i].rsvp.length; k++){
                    rsvp += lx.map.eventPerson(d[i].id, d[i].rsvp[k]);
                    lx.map.personEvent(d[i].rsvp[k].pid, lx.map.events[lx.map.events.length-1] );
                }
                
                $("#events").append('<div class="event" id="E'+ d[i].id +'" data-id="'+ d[i].id +'" data-type="'+ d[i].typeCode +'"><div>'+
                                    //(d[i].cover ? '<div class="cover"><img src="'+ d[i].cover +'" /></div>' : '')+
                                    '<div class="cover">'+ (d[i].cover ? '<img src="'+ d[i].cover +'" />' : '<i class="fas fawe-map-marker-alt red"></i>') +'</div>'+
                                    '<div class="dd">'+ lx.btn.genAll( d[i].dd ) +'</div>'+
                                    '<div class="txt">'+
                                             '<div class="type">'+ d[i].type +'</div>'+
                                             '<div class="title">'+ d[i].label +'</div><div class="hr"></div>'+
                                             (d[i].location ? '<label for="location">Address:</label><div class="location"><a href="javascript:lx.map.selectAsset('+ d[i].id +', \'E\')"><i class="fas fawe-map-marker-alt" ></i> '+ d[i].location +'</a></div>' : '')+
                                             '<label>Start:</label>'+'<div class="time">'+ d[i].start +'</div>'+
                                             '<label>Duration:</label>'+'<div class="time timer '+ d[i].color + '">'+ lx.map.timerDisp(d[i].time) +'</div>'+
                                             ( d[i].typeCode.startsWith("I_") ? "" :
                                                 '<label>End:</label>'+'<div class="time">'+ d[i].end +'</div>'+
                                                 '<label>Total Duration:</label>'+'<div class="time">'+ d[i].duration +'</div>')+
                                             (d[i].btnEnd ? lx.btn.genAll( d[i].btnEnd ) : "")+
                                             '<div class="feed-article_text">'+ d[i].details + '</div>'+
                                    '</div>'+
                                    '</div><div>'+
                                     '<div class="rsvp">'+ rsvp +'</div>' +
                                     d[i].comm +
                                    '</div></div>');
                lx.comment.initAll();
                const item = document.getElementById("E"+ d[i].id );
                item.addEventListener('dragenter', lx.map.dragEvent.enter );
                item.addEventListener('dragleave', lx.map.dragEvent.leave );
                item.addEventListener('dragover', lx.map.dragEvent.over );
                item.addEventListener('drop', lx.map.dragEvent.drop );
                //$("#E"+ d[i].pid ).on('drop', handleDrop).on('dragenter', lx.map.handleDragEnter).on('dragleave', lx.map.handleDragLeave);
            }
        }
    },
    setAssets: (d, pan) => {
        let displayedCnt = 0;
        for (let i = 0; i < d.length; i++){
            let exists = false;
            for (let j = 0; j < lx.map.assets.length; j++){
                if (lx.map.assets[j].id == d[i].id) {
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                lx.map.addAsset (d[i], pan);
                let asset = lx.map.assets[lx.map.assets.length-1];
                //setEventPin( d[i] );
                // rsvp records
                let asig = "";
                for(let k = 0; k < d[i].asig.length; k++){
                    asig += lx.map.assetPerson(d[i].id, d[i].asig[k]);
                    lx.map.personAsset(d[i].asig[k].cid, lx.map.assets[lx.map.assets.length-1] );
                }

                let locHide = ((d[i].asig.length > 0 && !d[i].typeCode.startsWith('BLD')) ? ' style="display:none"' : '');
                let info = [];
                if (d[i].sType) info.push(d[i].sType );
                if (d[i].make) info.push('Make: '+d[i].make );
                if (d[i].model) info.push('Model: '+d[i].model );
                if (d[i].year) info.push('Year: '+d[i].year );
                if (d[i].serial) info.push('Serial No: '+d[i].serial );
                if (d[i].regPlate) info.push('LPN: '+d[i].regPlate );
                if (d[i].owner) info.push('Owner: '+d[i].owner );
                if (d[i].leasedBy) info.push('Leased To: '+d[i].leasedBy );
                $("#assets").append('<div class="irRow asset" id="A'+ d[i].id +'" data-id="'+ d[i].id +'" data-type="'+ d[i].typeCode +'">'+
                                    '<div class="lp-map-asset-body">'+
                                        '<div class="lxIrCol-IMAGEW">'+ (d[i].cover ? '<div class="lxImage-TRACK_OBJ"><img src="'+ d[i].cover +'" /></div>' : '<i class="'+ d[i].icon +'" aria-hidden="true"></i>') +'</div>'+
                                        '<div class="lxIrCol-INFO_COL">'+
                                            '<div class="lp-map-asset-heading"><p class="name"><span class="vendor">'+ d[i].label +'</span></p>'+
                                            '<span class="lp-map-asset-type"><span data-map-type-label>Type:</span> '+ d[i].type +'</span></div>'+
                                            (info.length ? '<p class="info">'+ info.join(" | ") +'</p>' : '')+
                                            (d[i].location ? '<p class="info location"'+ locHide +'>Address: '+
                                                            (lx.map.type == 'T' ? '<a href="javascript:void(0);" onclick="lx.map.selectAsset('+ d[i].id +', \'A\', this)">'+d[i].location+'</a>' : d[i].location)+
                                                            '</p>' : '')+
                                        '</div>'+
                                    '</div>'+
                                        '<div class="lp-map-asset-actions t-ButtonRegion-buttons">'+
                                            '<a class="t-Button t-Button--icon t-Button--iconLeft lp-map-asset-edit" href="'+ d[i].editLink +'"><span class="t-Icon far fawe-edit" aria-hidden="true"></span><span class="t-Button-label" data-map-edit-label>Edit</span></a>'+
                                            (d[i].location && !locHide ? '<button type="button" class="t-Button lp-map-asset-pin" data-map-pin onclick="lx.map.toggleAsset('+ d[i].id +',this)"><span class="cbx far fawe-square" aria-hidden="true"></span><span class="t-Button-label" data-map-pin-label>Show on map</span></button>' : '')+
                                        '</div>'+
                                        '<div class="asig">'+ asig +'</div>' +
                                    '</div>');
                const item = document.getElementById("A"+ d[i].id );
                item.addEventListener('dragenter', lx.map.dragAsset.enter );
                item.addEventListener('dragleave', lx.map.dragAsset.leave );
                item.addEventListener('dragover', lx.map.dragAsset.over );
                item.addEventListener('drop', lx.map.dragAsset.drop );
                //$("#E"+ d[i].pid ).on('drop', handleDrop).on('dragenter', lx.map.handleDragEnter).on('dragleave', lx.map.handleDragLeave);
                // toogle first element for contact view or all for tracking
                if (d[i].location && !locHide && (lx.map.type == 'T' || displayedCnt == 0)) {
                    lx.map.toggleAsset(d[i].id, document.getElementById('A'+ d[i].id) );
                    displayedCnt++;
                }
            }
        }
    },
    getPins: (pan) => {
        //lx.load.add();
        apex.server.process('getPointLast', {x01:null, x02: lx.map.type},{
            type: "GET",
            dataType: "json",
            success: (d) => {
                //lx.load.remove();
                lx.map.setPins(d.points, pan);
                lx.map.setEvents(d.events, pan);
                lx.map.setAssets(d.assets, pan);
                document.dispatchEvent(new Event('lpmaploaded'));
                if (pan) setTimeout(()=>{
                    if ($("#SR_map_tab").hasClass("a-Tabs-selected")) lx.map.fitBounds(lx.map.bounds);
                    else lx.map.reBoundPending = true;
                }, 1000);
            }
        })
    },
    getPinsOnly: () => {
        apex.server.process('getPointsOnly', {}, {
            type: "GET",
            dataType: "json",
            success: (d) => {
                for (let i = 0; i < d.points.length; i++) {
                    lx.map.updatePin( lx.map.emps.filter(e => {return e.pid == d.points[i].pid})[0], d.points[i]);
                }
            }
        });
    },
    searchKeyDown: (e) => {
        if (e.keyCode == 13) e.preventDefault();
        return false;
    },
    searchPerson: (e) => {
        let term = e.target.value.toLowerCase();
        if (term.length === 0) {
            $("#people .person").show();
		} else {
            $("#people .person").each( function () {
                let $box = $(this);
                let name = $box.find(".name").text().toLowerCase();
                let tags = $box.find(".tags").text().toLowerCase();
                let address = $box.find(".address").text().toLowerCase();
                if (name.includes(term) || tags.includes(term) || address.includes(term) ) $box.show();
                else {$box.hide();}
            });
        }
        
        if (e.keyCode == 13) e.preventDefault();
        return false;
    },
    searchSelected: (e) => {
        let term = e.target.value.toLowerCase();
        if (term.length === 0) {
            $("#details .person").show();
		} else {
            $("#details .person").each( function () {
                let $box = $(this);
                let name = $box.find(".name").text().toLowerCase();
                let tags = $box.find(".tags").text().toLowerCase();
                let address = $box.find(".address").text().toLowerCase();
                if (name.includes(term) || tags.includes(term) || (address && address.includes(term)) ) $box.show();
                else {$box.hide();}
            });
        }
        
        if (e.keyCode == 13) e.preventDefault();
        return false;
    },
    searchAssets: (e) => {
        lx.map.filterAssets('lxMapAssetFilter');
        if (e.keyCode == 13) e.preventDefault();
        return false;
    },
    filterEvents: () => {
        let filter = $v("lxMapEventFilter").split(":");
        $(".event").hide();
        for (let i = 0; i < filter.length; i++) {
            $(".event[data-type='"+ filter[i] +"']").show();
        }
    },
    filterAssets: (pId) => {
        let filter = $v(pId).split(":");
        const term = ($('#SR_assets input[data-map-search="assets"]').val() || '').toLowerCase();
        $("#assets .asset").each(function () {
            const row = $(this);
            row.toggle(filter.includes(this.dataset.type) && row.find('.lxIrCol-INFO_COL').text().toLowerCase().includes(term));
        });
    },
    filterMap: (e) => {
        let filter = $v('lxMapFilter').split(":");
        // Employees
        let fP = filter.includes("P");
        if (fP != lx.map.filterVal.includes("P")){
            for (let i = 0; i < lx.map.emps.length; i++) {
                const e = lx.map.emps[i];
                if (e.pin){
                    if (fP) lx.map.markerCluster.addMarker(e.pin);
                    else lx.map.markerCluster.removeMarker(e.pin);
                }
            }
        }
        let fE = filter.includes("E");
        if (fE != lx.map.filterVal.includes("E")){
            for (let i = 0; i < lx.map.events.length; i++) {
                const e = lx.map.events[i];
                if (e.pin){
                    if (fE) lx.map.markerCluster.addMarker(e.pin);
                    else lx.map.markerCluster.removeMarker(e.pin);
                }
            }
        }
        // Assets
        let fA = filter.includes("A");
        if (fA != lx.map.filterVal.includes("A")){
            for (let i = 0; i < lx.map.assets.length; i++) {
                const e = lx.map.assets[i];
                if (e.pin){
                    if (fA) lx.map.markerCluster.addMarker(e.pin);
                    else lx.map.markerCluster.removeMarker(e.pin);
                }
            }
        }
        // POI
        let fI = filter.includes("I");
        if (fI != lx.map.filterVal.includes("I")){
            lx.map.applyTheme();
        }
        // populate so we have old value to compare
        lx.map.filterVal = $v('lxMapFilter').split(":");
    },
    endEvent: (id, pThis) => {
        lx.load.add();
        apex.server.process('endEvent', {x01:id},{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                for (let j = 0; j < lx.map.events.length; j++){
                    if (lx.map.events[j].id == id) {
                        lx.map.events[j].remove();
                        exists = true;
                        break;
                    }
                }
                $(pThis).closest(".event").remove();
            }
        });
    },
    handleEventPerson: (pEventId, pPersonId, pAction) => {
        lx.load.add();
        apex.server.process('handleEventPerson', {
            x01:pEventId,
            x02:pPersonId,
            x03:pAction
        },{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                if (d.err) console.log(d.err);
                else {
                    if (d.msg) console.log(d.msg);
                    // find event
                    let event;
                    for (let i = 0; i < lx.map.events.length; i++) {
                        const e = lx.map.events[i];
                        if (e.id == pEventId) {
                            event = e;
                            break;
                        }
                    }
                    
                    if (pAction == 'A'){
                        let $rsvp = $("#E"+ pEventId +' .rsvp')
                        if ($rsvp.find(".rec[data-pid='"+ pPersonId +"']").length == 0) $rsvp.append( lx.map.eventPerson(pEventId, d.rsvp) );
                        lx.map.personEvent(pPersonId, event);
                        event.rsvp.push(d.rsvp);
                    } else if (pAction == 'D' || pAction == 'L') {
                        $("#E"+ pEventId +' .rsvp .rec[data-pid="'+ pPersonId +'"]').remove();
                        $('#PE'+pPersonId+'_'+pEventId).remove();
                        event.rsvp.splice(event.rsvp.findIndex( o => {return o.pid == pPersonId}), 1);
                    }
                }
            }
        });
    },
    handleAssetPerson: (pAssetId, pContactId, pAction) => {
        // find asset
        let asset = lx.map.assets.filter( (a)=>{return a.id == pAssetId} )[0];

        if ( pAction == 'A' && (asset.typeCode.startsWith('EQP') /*|| asset.typeCode.startsWith('BLD')*/) && asset.asig.length >= 1 ) {
            lx.info.error("Only one person allowed!");
            return;
        }
        lx.load.add();
        apex.server.process('handleAssetPerson', {
            x01:pAssetId,
            x02:pContactId,
            x03:pAction
        },{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                if (d.err) console.log(d.err);
                else {
                    if (d.msg) console.log(d.msg);
                    
                    if (pAction == 'A'){
                        let $asig = $("#A"+ pAssetId +' .asig')
                        if ($asig.find(".rec[data-cid='"+ pContactId +"']").length == 0) $asig.append( lx.map.assetPerson(pAssetId, d.asig) );
                        lx.map.personAsset(pContactId, asset);
                        asset.asig.push(d.asig);
                        if (asset.pin && !asset.typeCode.startsWith('BLD') ) {
                            lx.map.markerCluster.removeMarker(asset.pin);
                            $("#A"+ pAssetId ).find(".location, label[for='location']").hide();
                        }
                    } else if (pAction == 'D') {
                        $("#A"+ pAssetId +' .asig .rec[data-cid="'+ pContactId +'"]').remove();
                        $('#PA'+pContactId+'_'+pAssetId).remove();
                        if (asset.pin && !asset.typeCode.startsWith('BLD') ) {
                            lx.map.markerCluster.addMarker(asset.pin);
                            $("#A"+ pAssetId ).find(".location, label[for='location']").show();
                        };
                        asset.asig.splice(asset.asig.findIndex( o => {return o.cid == pContactId}), 1);
                    }
                }
            }
        });
    },
    setAddressLatLng: (pAdrId, pLat, pLng, pValid) => {
        apex.server.process('setAddressLatLng', {
            x01:pAdrId,
            x02:pLat,
            x03:pLng,
            x04:pValid
        },{
            type: "POST",
            dataType: "json",
            success: (d) => {
                if (d.err) console.log(d.err);
                else if (d.msg) console.log(d.msg);
            }
        });
    },
    tabOpen: (pThis)=> {
        let tab = $(pThis).attr('aria-controls');
        if (tab == 'SR_map' || tab == 'SR_events'){
            $("#btnCreateEvent").show();
            $("#btnCreateAsset").hide();
        } else if (tab == 'SR_assets'){
            $("#btnCreateEvent").hide();
            $("#btnCreateAsset").show();
        }
        if (tab == 'SR_map') lx.map.reBound();
    },
    hideDetails: (pType, pId) => {
        if (pType == 'P') {
          $("#details").removeClass("hideDetails");  
          $("#mapPanel").removeClass("col-10");     
          $("#mapPanel").addClass("col-8"); 
          lx.map.empDetails(pId);
        } else if (pType == 'C') {
            $("#details").addClass("hideDetails");  
            $("#mapPanel").addClass("col-10");     
            $("#mapPanel").removeClass("col-8"); 
        } else {
          $("#details").addClass("hideDetails");  
          $("#mapPanel").addClass("col-10");     
          $("#mapPanel").removeClass("col-8"); 
          $(".person").removeClass("selected");
        }
    },
    empDetails: (pId) => {
        lx.load.add();
        $("#details > .cont").html('<p>Loading...</p>');
        $(".person").removeClass("selected");
        $("#P"+pId).addClass("selected");
        apex.server.process('empDetails', {
            x01:pId,
        },{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                if (d.err) console.log(d.err);
                else {
                    let p = lx.map.emps.filter((i)=>{return i.pid == pId})[0];
                    let img = $.extend(true, {}, p.img);
                    img.size = 'XL';
                    let html = '<div class="main">'+
                                '<div class="imgs">'+ 
                                  lx.profile.genPic(img) +
                                  (d.rank && d.rank.img ? '<div class="rank"><img src="'+ d.rank.img +'" /></div>' : '')+
                                '</div>'+
                                '<p class="name">'+ p.label +'</p>'+
                                '<p class="wp">'+ p.wp +'</p>'+
                                (d.rank && d.rank.name ? '<p class="rankName">'+ d.rank.name +'</p>' : '')+
                               '</div>';
                    // Certificates
                    if (d.cert && d.cert.length > 0) {
                        let certs = '';
                        for (let i = 0; i < d.cert.length; i++) {
                            const c = d.cert[i];
                            certs += '<div class="cert">'+
                                        '<div class="img"><img src="'+ c.img +'" /></div>'+
                                        '<div class="txt">'+
                                         '<p class="name">'+ c.name +'</p>'+
                                         (c.exp ? '<p class="exp">'+ c.exp +'</p>' : '')+
                                        '</div>'+
                                     '</div>'
                        }
                        html += '<div class="list"><div class="hdr">Certifications</div>'+ certs +'</div>';
                    }
                    // Assets
                    if (d.assets && d.assets.length > 0) {
                        let asset = '';
                        for (let i = 0; i < d.assets.length; i++) {
                            const a = d.assets[i];
                            const as = lx.map.assets.filter( (v) => {return v.id == a.id} )[0] ;
                            asset += '<div class="cert">'+
                                        '<div class="img">'+ (as.cover ? '<img src="'+ as.cover +'" />' : '<i class="'+ as.icon +'"></i>') +'</div>'+
                                        '<div class="txt">'+
                                         '<p class="name">'+ as.label +'</p>'+
                                         (a.start ? '<p class="exp"><i class="far fawe-check-square" ></i> '+ a.start +'</p>' : '')+
                                        '</div>'+
                                     '</div>'
                        }
                        html += '<div class="list"><div class="hdr">Assigned Assets</div>'+ asset +'</div>';
                    }

                    $("#details > .content").html('<div>'+ html +'</div>');
                }
            }
        });
    },
    selectAll: () => {
        let $c = $('#people .person:visible:not(.pinned)');
        for (let i = 0; i < $c.length; i++) {
            lx.map.togglePin($c[i].dataset.id, $c[i]);
        }
    },
    deselectAll: (pSelected) => {
        let $c = (pSelected ? $('#details .person:visible') : $('#people .person:visible.pinned') );
        
        for (let i = 0; i < $c.length; i++) {
            lx.map.togglePin($c[i].dataset.id, (pSelected ? $("#P"+$c[i].dataset.id) : $c[i]) );
        }
        lx.map.reBound();
    },
    reset: () => {
        lx.map.clearDirections();
        let $c = $('#people .person.pinned');
        for (let i = 0; i < $c.length; i++) {
            lx.map.togglePin($c[i].dataset.id, $c[i]);
        }
        lx.map.reBound();
    },
    getPinned: (pType, pAll) => {
        
        switch (pType) {
            case 'A':
                return (pAll ? $(".asset.pinned").map(function () {return $(this).attr("data-id")} ).toArray() : (Number($(".asset.pinned").attr("data-id")) || null) );
            case 'C':
                return $(".person.pinned").map(function () {return $(this).attr("data-id")} ).toArray();
            case 'CA':
                return $("#routeList .route").map(function () {return $(this).attr("data-addr")} ).toArray();
            default:
                break;
        }
    },
    getAsset: (pAssetId) => {
        for (let i = 0; i < lx.map.assets.length; i++) {
            const asset = lx.map.assets[i];
            if (asset.id == pAssetId) {
                return asset;
                break;
            }
        }
        return null;
    },
    getPersonByAddrId: (pAddrId) => {
        for (let i = 0; i < lx.map.emps.length; i++) {
            const emp = lx.map.emps[i];
            if (emp.addrId == Number(pAddrId) ) {
                return emp;
            }
        }
        return null;
    },
    getRoute: (pAssetId, pAddrId) => {
        for (let i = 0; i < lx.map.routes.length; i++) {
            const d = lx.map.routes[i];
            if (d.assetId == pAssetId && d.addrId == pAddrId){
                return d;
            }
        }
    },
    clearDirections: (pAssetId) => {
        if (pAssetId) {
            $('#routeList .routeVal[data-id='+ pAssetId +']').remove();
            if (lx.map.routes)
                for (let i = 0; i < lx.map.routes.length; i++) {
                    const d = lx.map.routes[i];
                    if (d.assetId == pAssetId && d.directionLine && d.directionLine.map) d.directionLine.setMap(null);
                }
        } else {
            lx.btn.hightlight("getRoutes");
            $('#printRoutes').hide();
            lx.info.clear();
        }
    },
    printRoutes: (pAssetId, pAddrId) => {
        let assetId = lx.map.getPinned('A');
        lx.load.add();
        apex.server.process('printRoutes', {
            x01:assetId,
            x02:lx.map.getTravelMode(),
            f01:lx.map.getPinned('CA')
        },{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                if (d.err) lx.info.error(d.err);
                else {
                    eval(d.link);
                }
            }
        });
    },
    openRouteReport: () => {
        lx.load.add();
        apex.server.process('routesReport', {
            f01:lx.map.getPinned('A', true),
            f02:lx.map.getPinned('CA')
        },{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                if (d.err) lx.info.error(d.err);
                else {
                    apex.navigation.redirect(d.link);
                }
            }
        });
    },
    lineColors: ['#000000','#FF0000','#0000FF','#FF00FF','#800000','#008000','#800080','#008080','#000080','#A52A2A','#DC143C','#FF6347','#CD5C5C','#FF4500','#B8860B','#556B2F','#6B8E23','#006400','#008000','#2E8B57','#2F4F4F','#008B8B','#1E90FF','#6495ED','#191970','#00008B','#0000CD','#8A2BE2','#4B0082','#483D8B','#8B008B','#800080','#9932CC','#C71585','#FF1493','#8B4513','#A0522D','#BC8F8F'],
    lineColorIndex: 0,
    renderDirection: (pAssetId, pAddrId) => {
        let route = lx.map.getRoute(pAssetId, pAddrId);
        if (route.direction) {
            $routeBox = $("#routeList .person[data-addr="+ pAddrId +"] .routeVal[data-id="+ pAssetId +"] .routeRender");
            if (route.directionLine && route.directionLine.map) {
                route.directionLine.setMap(null);
                $routeBox.removeClass("rendered").css("background-color","");
            } else {
                lx.map.boundsDir = new google.maps.LatLngBounds();
                const dir = google.maps.geometry.encoding.decodePath(route.direction);
                for (let i = 0; i < dir.length; i++) {
                    lx.map.boundsDir.extend(dir[i]);
                }
                lx.map.map.fitBounds(lx.map.boundsDir);
                route.directionLine = new google.maps.Polyline({
                    map:            lx.map.map,       
                    path:           dir,//google.maps.geometry.encoding.decodePath(route.direction),
                    strokeColor:    lx.map.lineColors[lx.map.lineColorIndex],//"#02535B",
                    strokeOpacity:  0.7,
                    strokeWeight:   3
                });
                $routeBox.addClass("rendered").css("background-color",lx.map.lineColors[lx.map.lineColorIndex]);
                if ( lx.map.lineColorIndex >= (lx.map.lineColors.length-1) ) lx.map.lineColorIndex = 0;
                else lx.map.lineColorIndex++;
            }
        } else {
            //getDirection
            lx.info.clear();
            lx.map.fetchDirection(pAssetId, pAddrId);
        }
    },
    sortRouteAssetId: null,
    sortRouteSet: (pAssetId, pRemove) => {
        const asset = lx.map.getAsset(pAssetId);
        let $select = $("#sortRoute");
        let optionCnt = $select.find('option').length;
        let setOption = null;
        if (pRemove) {
            $select.find('option[value='+ asset.id +']').remove();
            optionCnt--;
            lx.map.clearDirections(asset.id);
            if (lx.map.sortRouteAssetId == pAssetId) lx.map.sortRoutes($select.find('option').first().val());
        } else {
            $select.append('<option value="'+ asset.id +'">'+ asset.label +'</option>');
            optionCnt++;
            lx.map.clearDirections();
            if (optionCnt == 1) lx.map.sortRoutes( asset.id );
        }
        // show / hide sort lov
        if (optionCnt > 1) $select.parent().show();
        else $select.parent().hide();
    },
    sortRoutes: (pAssetId) => {
        let $select = $("#sortRoute");
        if (pAssetId) lx.map.sortRouteAssetId = pAssetId;
        else lx.map.sortRouteAssetId = $select.val();
        
        if (lx.map.sortRouteAssetId) $select.val(lx.map.sortRouteAssetId);
        else return;

        let $wrapper = $('#routeList');
        $wrapper.find('.route').sort(function (a, b) {
            const $a = $(a).find(".routeVal[data-id="+ lx.map.sortRouteAssetId +"]");
            const $b = $(b).find(".routeVal[data-id="+ lx.map.sortRouteAssetId +"]");
            return $a.data("dist") - $b.data("dist");
        })
        .appendTo( $wrapper );
    },
    setTravelMode: (e) => {
        let el = e.target;
        let mode = el.dataset.val;
        $(".travelMode .selected").removeClass('selected');
        $(el).addClass('selected');
        lx.map.clearDirections();
    },
    getTravelMode: () => {
        return $(".travelMode .selected")[0].dataset.val;
    },
    setRoute: (pAssetId, pAddrId, pDistance, pDuration, pRoute) => {
        let routeExists = false;
        let route = {};
        for (let i = 0; i < lx.map.routes.length; i++) {
            if (lx.map.routes[i].assetId == pAssetId && lx.map.routes[i].addrId == pAddrId) {
                route = lx.map.routes[i];
                routeExists = true;
                break;
            }
        }
        route.distance = pDistance;
        route.duration = pDuration;
        route.direction = pRoute;
        if (!routeExists){
            route.assetId = pAssetId
            route.addrId  = pAddrId;
            lx.map.routes.push( route );
        }
        let contact = lx.map.getPersonByAddrId(pAddrId);

        let $route = $("#routeList .person[data-addr="+ pAddrId +"]");
        //$route.attr("data-dist", route.distance.value).attr("data-dur", route.duration.value); 
        let html =  '<div class="routeVal" data-id="'+ pAssetId +'" data-dist="'+  route.distance.value +'" data-dur="'+  route.duration.value +'">'+
                        '<div class="routeAsset">'+ lx.map.getAsset(pAssetId).label +'</div>'+
                        '<div>'+ route.distance.text +'</div><div>'+ route.duration.text +'</div>'+
                        '<div onclick="lx.map.renderDirection('+pAssetId+', '+pAddrId+');" class="routeRender"><i class="fas fawe-map-marked-alt"></i></div>'+
                    '</div>';
        let $routeVal = $route.find(".routeVal[data-id="+ pAssetId +"]");
        if ($routeVal.length == 0)
            $route.append(html);
        else $routeVal.replaceWith(html);
        if (lx.map.sortRouteAssetId == pAssetId) lx.map.sortRoutes(pAssetId);
    },
    storeRoute: (pAssetId, pAddrId, pDistance, pDuration, pDirection) => {
        let direction = JSON.stringify(pDirection);
        
        apex.server.process('storeRoute', {
            x01:pAssetId,
            x02:pAddrId,
            x03:pDistance.text,
            x04:pDistance.value,
            x05:pDuration.text,
            x06:pDuration.value,
            x07:lx.map.getTravelMode(),
            p_clob_01:direction
        },{
            type: "POST",
            dataType: "json",
            success: (d) => {
                if (d.err) console.log(d.err);
                else console.log(d.msg)
            }
        });
    },
    fetchDirection: (pAssetId, pAddrId) => {
        lx.map.directionsService.route({origin: lx.map.getPersonByAddrId(pAddrId).address, 
                                        destination: lx.map.getAsset(pAssetId).location, 
                                        travelMode: lx.map.getTravelMode(),
                                        unitSystem: google.maps.UnitSystem[$v("gmapSystemUnit")]
                                    }, 
          function(result, status) {
            if (status == 'OK') {
                let distance = result.routes[0].legs[0].distance;
                let duration = result.routes[0].legs[0].duration;
                duration.text = duration.text.replace(" hours", "h").replace(" hour", "h").replace(" mins", "m").replace(" min", "m");
                lx.map.setRoute  (pAssetId, pAddrId, distance, duration, result.routes[0].overview_polyline);
                lx.map.renderDirection(pAssetId, pAddrId);
                lx.map.storeRoute(pAssetId, pAddrId, distance, duration, result.routes[0].overview_polyline);
            }
          });
    },
    storeDistances: (pAssetId, disArr) => {
        lx.load.add();
        apex.server.process('storeDistances', {
            x01:pAssetId,
            x02: lx.map.getTravelMode(),
            f01: disArr.ids,
            f02: disArr.disTxt,
            f03: disArr.disVal,
            f04: disArr.durTxt,
            f05: disArr.durVal
        },{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                if (d.err) console.log(d.err);
                else console.log(d.cnt);
            }
        });
    },
    fetchMatrix: (pAssetId, pAddrIds) => {
        let lAssetAdr = lx.map.getAsset(pAssetId).location;
        let lConAdr   = [];
        let lCons     = [];
        let disArr = {ids:[...pAddrIds], disTxt: [], disVal: [], durTxt: [], durVal: []};
        for (let i = 0; i < disArr.ids.length; i++) {
            const c = lx.map.getPersonByAddrId( disArr.ids[i] );
            lCons.push( c );
            lConAdr.push( c.address );
        }
        lx.map.distanceMatrix.getDistanceMatrix({
            origins: [lAssetAdr],
            destinations: lConAdr,
            travelMode: lx.map.getTravelMode(),
            unitSystem: google.maps.UnitSystem[$v("gmapSystemUnit")]
        }, function(result, status){
            if (status == "OK"){
                for (let i = 0; i < disArr.ids.length; i++) {
                    const dist = result.rows[0].elements[i];
                    const con = lCons[i];
                    
                    if (dist.status == 'OK') {
                        dist.duration.text = dist.duration.text.replace(" hours", "h").replace(" hour", "h").replace(" mins", "m").replace(" min", "m")
                    } else {
                        dist.distance = {text: 'N/A', value: 40075000};// equator circumference ;)
                        dist.duration = {text: 'N/A', value: 2592000};// 30 days
                        if (dist.status == 'ZERO_RESULTS') lx.info.error("No route could be found for "+ con.label +"!");
                        else if (dist.status == 'NOT_FOUND') lx.info.error(con.label +" address can't be geocoded!");
                    }
                    disArr.disTxt.push(dist.distance.text);
                    disArr.disVal.push(dist.distance.value);
                    disArr.durTxt.push(dist.duration.text);
                    disArr.durVal.push(dist.duration.value);

                    lx.map.setRoute(pAssetId, disArr.ids[i], dist.distance, dist.duration, null );
                }
                lx.map.storeDistances(pAssetId, disArr);
            } else {
                lx.info.error("Not able to calculate!");
                console.log(result);
                console.log(status);
            }
        });
    },
    getRoutes: () => {
        lx.map.routes = [];
        let assets = lx.map.getPinned('A',true);
        let contacts = lx.map.getPinned('CA');
        if (assets.length == 0) {
            lx.info.error("Please select one asset!");
            return;
        } else if (contacts.length == 0){
            lx.info.error("Please select at least one contact!");
            return;
        }
        lx.info.clear();

        lx.load.add();
        apex.server.process('getRoutes', {
            x01: lx.map.getTravelMode(),
            f01: assets,
            f02: contacts
        },{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                if (d.err) console.log(d.err);
                else {
                    for (let x = 0; x < d.length; x++) {
                        const asset = d[x];
                        const assetId = asset.objId;
                        let fetchAddr = [];
                        for (let i = 0; i < asset.routes.length; i++) {
                            const route = asset.routes[i];
                            if (route.distance) lx.map.setRoute(assetId, route.addrId, route.distance, route.duration, (route.direction ? JSON.parse(route.direction) : null) );
                            else {
                                fetchAddr.push(route.addrId);//lx.map.fetchDirection(assetId, route.addrId);
                                // maximum of 25 origins or 25 destinations, maximum of 100 elements per request
                                if (fetchAddr.length == 25) {
                                    lx.map.fetchMatrix(assetId, fetchAddr);
                                    fetchAddr = [];
                                }
                            }
                        }
                        if (fetchAddr.length > 0) lx.map.fetchMatrix(assetId, fetchAddr);
                        lx.btn.unhightlight("getRoutes");
                        $('#printRoutes').show();
                    }
                    
                }
            }
        });
    }
};
